import { defineStore } from "pinia";
interface utmInfo {
    utm_source: string;
    utm_medium: string;
    utm_campaign: string;
    utm_term: string;
    utm_content: string;
}
const globalStore = defineStore("global", {
    state: () => {
        return {
            type: 0 as number,

            cnt_citizen: 0 as number,
            cnt_citizen_report: 0 as number,
            cnt_report: 0 as number,

            introTab: 0 as number,
            reportTab: 0 as number,
            boardTab: 0 as number,
            useTerms: "" as string,
            snsInfo: {} as any,

            isRefreshing: false as boolean,

            utmInfo: {} as utmInfo,

            chart: "",
        };
    },
    actions: {
        setMypageType(type: number) {
            this.type = type;
        },

        chartSet(type: string) {
            this.chart = type;
        },

        setCnt(cnt_citizen: number, cnt_citizen_report: number, cnt_report: number, useTerms: string) {
            this.cnt_citizen = cnt_citizen;
            this.cnt_citizen_report = cnt_citizen_report;
            this.cnt_report = cnt_report;
            this.useTerms = useTerms;
        },
        setIntroTab(tab: number) {
            this.introTab = tab;
        },
        setReportTab(tab: number) {
            this.reportTab = tab;
        },
        setBoardTab(tab: number) {
            this.boardTab = tab;
        },
        setSnsInfo(snsInfo: any) {
            this.snsInfo = snsInfo;
        },

        setRefreshing(isRefreshing: boolean) {
            this.isRefreshing = isRefreshing;
        },

        setUtmInfo(utmInfo: any) {
            this.utmInfo = utmInfo;
        },
    },
});

export default globalStore;
